import type { ReactNode } from "react";

export default function Sidebar({ children }: { children: ReactNode }): ReactNode {
  return <aside className="sidebar">{children}</aside>;
}
